function throttle(fn: any, delay: any) {
  let timer: any = null;
  return (...args: any) => {
    if (!timer) {
      let ret = fn.apply(null, ...args);
      timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
      }, delay);
      return ret;
    }
  };
}
const Throttle = {
  mounted(el: any, binding: any) {
    console.log(binding.arg);
    let { arg } = binding;
    arg = arg || "click";

    let { handler, delay } = binding.value;
    el._handler = throttle(handler, delay);
    el.addEventListener(arg, el._handler);
  },
  unmounted(el: any, binding: any) {
    el.removeEventListener(binding.arg, el._handler);
    delete el._handler;
  },
};
(Throttle as any).install = function (app) {
  app.directive("throttle", Throttle);
};


export default Throttle;
